'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (loop) {
  var newLoop = loop;

  if (loop === 'off') {
    newLoop = 'loop';
  } else if (loop === 'loop') {
    newLoop = 'loop-playlist';
  } else {
    newLoop = 'off';
  }
  return newLoop;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplaylist/lib/util/getLoopState.js
// module id = 346
// module chunks = 0